import Vue from 'vue';

const calc = (el, binding) => {
  const elCopy = el;
  let offsetHeight = 0;
  const padding = binding.value.offset ? binding.value.offset : 0;

  if (binding.value && binding.value.el) {
    binding.value.el.forEach((item) => {
      const selectedEl = document.querySelector(item);
      if (selectedEl) {
        offsetHeight += selectedEl.clientHeight;
      }
    });
  }

  const finalHeight = window.innerHeight - offsetHeight - padding;
  elCopy.style.height = `${finalHeight}px`;
  elCopy.style.overflow = 'auto';
};

let insertedTimeout = null;
let updatedTimeout = null;


Vue.directive('maxHeight', {
  inserted(el, binding) {
    clearTimeout(insertedTimeout);

    insertedTimeout = setTimeout(() => {
      calc(el, binding);
    }, 0);

    // Options for the observer (which mutations to observe)
    const config = { attributes: false, childList: true, subtree: true };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(() => {
      calc(el, binding);
    });

    // Start observing the target node for configured mutations
    observer.observe(el.parentElement.parentElement, config);
  },

  componentUpdated(el, binding) {
    clearTimeout(updatedTimeout);

    updatedTimeout = setTimeout(() => {
      calc(el, binding);
    }, 0);
  },
});
